import React from 'react';
import ReactMarkdown from 'react-markdown';
import postContent from './posts/multilingual-reasoning-content';

export default function MultilingualReasoning() {
  return (
    <main className="content">
      <div className="blog-post">
        <ReactMarkdown>{postContent}</ReactMarkdown>
      </div>
    </main>
  );
}
